// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","title":"App_title__wJw7v","codeBlock":"App_codeBlock__z6bGm","instruction":"App_instruction__alkmr"};